import { render, staticRenderFns } from "./GatewayForm.vue?vue&type=template&id=ed96cda6&scoped=true&"
import script from "./GatewayForm.vue?vue&type=script&lang=js&"
export * from "./GatewayForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed96cda6",
  null
  
)

export default component.exports